import { render, staticRenderFns } from "./ButtonFav.vue?vue&type=template&id=7ad8d3d4"
import script from "./ButtonFav.vue?vue&type=script&lang=js"
export * from "./ButtonFav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports